import { render, staticRenderFns } from "./AdminCompanies.vue?vue&type=template&id=e9a42514&"
import script from "./AdminCompanies.vue?vue&type=script&lang=ts&"
export * from "./AdminCompanies.vue?vue&type=script&lang=ts&"
import style0 from "./AdminCompanies.vue?vue&type=style&index=0&id=e9a42514&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports